import * as React from "react";
import moment from "moment";
// import { Link } from "react-router-dom";
import { Progress } from "antd";
import Pointicons from "../../../assets/svg/tinyPointsIcon.svg";
import { TemplateSub } from "../../../components/layouts/TemplateSub";
import {
  PointsHistoryController,
  PointHistoryData,
  GroupedPointHistory,
} from "@njoy/controller";
import PointsOverviewSkeleton from "./pointsOverviewSkeleton";
import Explorer from "../../../assets/profile/explorer.svg";
import Insider from "../../../assets/profile/insider.svg";
import Gold from "../../../assets/profile/gold.svg";
import Black from "../../../assets/profile/black.svg";
import PurpleNjoy from "../../../assets/profile/purpleNjoy.svg";
import LifePoints from "../../../assets/profile/pointsIcon.svg";
import AddIcon from "../../../assets/profile/addIcon.svg";
import { usePointCard } from "@njoy/controller";
import FiveRerrals from "../../../assets/svg/5referral.svg";
import FreeOffers from "../../../assets/svg/freeOffer.svg";
import IdConnect from "../../../assets/svg/idConnected.svg";
import PaidOffer from "../../../assets/svg/paidOffer.svg";
import Penalty from "../../../assets/svg/penalty.svg";
import PollAnswered from "../../../assets/svg/pollAnswered.svg";
import RefferralAward from "../../../assets/svg/referralAward.svg";
import RefferalReward from "../../../assets/svg/referralReward.svg";
import SharedOffer from "../../../assets/svg/sharedOffer.svg";

const headings = [
  { key: "activity", label: "Activity" },
  { key: "referral", label: "Referral History" },
];

export enum PMBCategory {
  ONBOARDING = "Onboarding Points",
  FREE_REDEMPTION = "Free Redemption Points",
  PAID_REDEMPTION = "Paid Redemption Points",
  REFERRAL = "Referral Points",
  REFERRAL_CONVERSION = "Referral Milestone Points",
  SHARED_OFFER = "Shared Offer Points",
  ENGAGEMENT = "Activity Points",
  RETENTION = "Loyalty Points",
  PENALTY = "Point Deduction",
}

export const PointsOverviewPage: React.FC = () => {
  const [currentPage, setCurrentPage] = React.useState<string>("activity");

  const categoryIconMap: Record<PMBCategory, string> = {
    [PMBCategory.ONBOARDING]: IdConnect,
    [PMBCategory.FREE_REDEMPTION]: FreeOffers,
    [PMBCategory.PAID_REDEMPTION]: PaidOffer,
    [PMBCategory.REFERRAL]: RefferralAward,
    [PMBCategory.REFERRAL_CONVERSION]: FiveRerrals,
    [PMBCategory.SHARED_OFFER]: SharedOffer,
    [PMBCategory.ENGAGEMENT]: PollAnswered,
    [PMBCategory.RETENTION]: RefferalReward,
    [PMBCategory.PENALTY]: Penalty,
  };

  const {
    customerTier,
    lifeTimePoint,
    pointBalance,
    currentMonthPoints,
    tiers,
    pointsForNextTier,
    loading: pointsCardLoading,
  } = usePointCard();

  const variables = {
    offset: 0,
    limit: 20,
    typeFilter: currentPage === "activity" ? "All" : "Referral",
  };

  const isReferralTab = currentPage === "referral";

  const subscribeRef = React.useRef<null | (() => () => void)>(null);
  React.useEffect(() => {
    if (subscribeRef.current) {
      const unsubscribe = subscribeRef.current();
      return () => {
        if (unsubscribe) unsubscribe();
      };
    }
    return undefined;
  }, [currentPage]);

  const progressPercent = Math.min(
    (pointBalance / (pointBalance + pointsForNextTier)) * 100,
    100,
  );

  return (
    <TemplateSub page="Points Overview">
      <div className="w-full flex-1 h-full overflow-y-auto pb-4">
        <div className="w-full flex-1  overflow-y-auto pb-7">
          {/* Points section */}
          <div className="px-[1rem]">
            <div className="w-full  rounded-[10px] p-5 bg-[linear-gradient(180deg,_#FFFFFF_0%,_#C7D0FF_100%)] cursor-pointer">
              <div className="bg-[#353535] rounded-[8px]">
                <div className=" p-4 flex flex-col gap-2 ">
                  <div className="flex justify-end items-center  gap-1">
                    <img
                      src={
                        customerTier === "Explorer"
                          ? Explorer
                          : customerTier === "Insider"
                            ? Insider
                            : customerTier === "Gold"
                              ? Gold
                              : Black
                      }
                      alt=""
                      width={18}
                      height={18}
                    />
                    <p className="text-base text-white font-extrabold">
                      {pointsCardLoading ? "..." : customerTier}
                    </p>
                  </div>
                  <div className="flex justify-between items-end">
                    <div className="flex flex-col gap-1">
                      <p className="text-xs text-white">Your Current Points</p>

                      <div className="flex items-center gap-1">
                        <img
                          src={PurpleNjoy}
                          alt="debit"
                          width={13}
                          height={11}
                        />
                        <h2 className="text-2xl text-white font-extrabold">
                          {pointsCardLoading ? "..." : pointBalance}
                        </h2>
                      </div>
                    </div>
                    <div className="mb-[6px] text-xs bg-[linear-gradient(180deg,_#FFFFFF_0%,_#C7D0FF_100%)] text-[#353535] px-2 py-[2px] rounded-md inline-block ">
                      {pointsCardLoading ? "..." : pointsForNextTier} points to{" "}
                      <span className="bg-[linear-gradient(270deg,_#FF8800_0%,_#FF165C_100%)] bg-clip-text text-transparent font-bold">
                        {pointsCardLoading
                          ? "..."
                          : tiers.find(
                              (cur) =>
                                cur.threshold ===
                                pointBalance + pointsForNextTier,
                            )?.name}{" "}
                        Tier
                      </span>
                    </div>
                  </div>

                  <Progress
                    percent={progressPercent}
                    showInfo={false}
                    strokeColor={{
                      "0%": "#3B82F6",
                      "100%": "#A855F7",
                    }}
                    trailColor="#4B5563"
                    strokeWidth={8}
                    className="mb-2"
                    style={{ transition: "all 0.3s ease" }}
                  />
                  <div className="flex justify-between items-end mt-2">
                    <div className="flex flex-col ">
                      <p className="text-xs text-white">
                        Points you collected this month
                      </p>

                      <div className="flex items-center gap-1">
                        <img src={AddIcon} alt="debit" width={14} height={14} />
                        <h2 className="text-base text-white font-extrabold">
                          {pointsCardLoading ? "..." : currentMonthPoints}
                        </h2>
                      </div>
                    </div>
                    <div className="flex flex-col items-end">
                      <div className="flex gap-[2px] items-center text-xs text-[#353535] rounded-md  ">
                        <img
                          src={LifePoints}
                          alt="debit"
                          width={14}
                          height={14}
                        />
                        <p className="text-white">Lifetime Points</p>
                      </div>
                      <p className="text-base text-white">
                        {pointsCardLoading ? "..." : lifeTimePoint}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p className="text-xl text-white font-medium px-[1rem] mt-8">
            Points History
          </p>
          {/* Navigation Tabs */}
          <div className="w-full flex gap-2 justify-center items-center p-4 ">
            {headings.map((tab) => (
              <div
                key={tab.key}
                className={`text-[12px] max-[430px]:px-3 shadow py-3 px-7 text-center w-full h-[42] rounded-[10px] text-white cursor-pointer transition duration-300 ${
                  currentPage === tab.key
                    ? " bg-[linear-gradient(270deg,#A151F9_0%,#0045E9_98.3%)] font-semibold"
                    : "bg-[#3C3E58]"
                }`}
                onClick={() => setCurrentPage(tab.key)}
              >
                {tab.label}
              </div>
            ))}
          </div>

          <PointsHistoryController variables={variables}>
            {({ pointHistory, loading, loadMore, hasMorePointsHistory }) => {
              const grouped = pointHistory.reduce(
                (acc, tx) => {
                  const date = new Date(tx.createdAt).toLocaleDateString();
                  if (!acc[date]) acc[date] = [];
                  acc[date].push(tx);
                  return acc;
                },
                {} as Record<string, typeof pointHistory>,
              );

              return (
                <>
                  <div className="px-[1rem]">
                    {loading && (
                      <div className="flex flex-col gap-3">
                        <PointsOverviewSkeleton />
                        <PointsOverviewSkeleton />
                        <PointsOverviewSkeleton />
                      </div>
                    )}

                    {Object.keys(grouped).length === 0 && !loading && (
                      <div className="text-[#9fafb5] text-center mt-8">
                        No point history found.
                      </div>
                    )}

                    {Object.entries(grouped).map(
                      ([date, groupedPointHistory], idx) => (
                        <div
                          key={date}
                          className={`w-full p-3 bg-[#1E1E1E] ${
                            idx === 0 ? "mt-[0.5rem]" : "mt-[1rem]"
                          } rounded-lg`}
                        >
                          <p className="text-white text-[13px] text-left">
                            {moment(date, "DD-MM-YYYY").format("Do MMMM YYYY")}
                          </p>
                          <hr className="bg-[#77777] mt-3 border w-full border-[#7777]" />
                          <div className="flex flex-col gap-3 w-full p-2">
                            {(groupedPointHistory as GroupedPointHistory[]).map(
                              (cur) => {
                                // PointHistoryData[]
                                const pointHistory: PointHistoryData[] =
                                  cur.pointHistory;
                                return pointHistory.map((cur) => (
                                  <div className="flex justify-between gap-1 items-center cursor-pointer">
                                    <div className="flex mt-3 items-center gap-4">
                                      <div>
                                        <img
                                          src={
                                            isReferralTab
                                              ? cur.referredProfileImage ||
                                                PurpleNjoy
                                              : categoryIconMap[
                                                  cur.category as PMBCategory
                                                ] || PurpleNjoy
                                          }
                                          alt=""
                                          width={25}
                                          height={25}
                                          className="rounded-full object-cover w-[27px] h-[27px]"
                                        />
                                      </div>

                                      <div className="flex flex-col gap-1 min-w-0">
                                        <p className="text-[12px] text-white w-full font-semibold truncate">
                                          {isReferralTab
                                            ? `${cur.referredFirstName ?? ""} ${cur.referredLastName ?? ""}`
                                            : cur.action}
                                        </p>

                                        <p className="text-[12px] text-white w-full opacity-50 font-semibold truncate">
                                          {cur.category}
                                        </p>
                                      </div>
                                    </div>

                                    <div className="flex gap-[2px] flex-col justify-end items-end mt-2">
                                      <p className="text-[11px] text-[#777] ">
                                        {moment(cur?.createdAt).format(
                                          "h:mm A",
                                        )}
                                      </p>

                                      <div className="flex gap-1 items-center">
                                        <div
                                          className={`flex gap-[2px] px-1 py-[2px] items-center rounded border ${
                                            cur.category === PMBCategory.PENALTY
                                              ? "bg-[#FEF3F2] border-[#E64646]"
                                              : "bg-[#DAFFB4] border-[#046E0D]"
                                          }`}
                                        >
                                          <img
                                            src={Pointicons}
                                            height={9}
                                            width={9}
                                            alt=""
                                          />
                                          <p
                                            className={`text-[10px] font-black ${
                                              cur.category ===
                                              PMBCategory.PENALTY
                                                ? "text-[#E64646]"
                                                : "text-[#046E0D]"
                                            }`}
                                          >
                                            {cur.category ===
                                            PMBCategory.PENALTY
                                              ? "-"
                                              : "+"}
                                            {cur.point}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ));
                              },
                            )}
                          </div>
                        </div>
                      ),
                    )}
                  </div>
                </>
              );
            }}
          </PointsHistoryController>
        </div>
      </div>
    </TemplateSub>
  );
};
